import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Title } from '../../Common/PageElement';
import { FeatureContent } from './FeatureContent';
import { FeatureBody, FeatureIcon, FeatureItem, FeatureSection, FeatureText, FeatureTitle } from './StyledFeatures';

function Features() {
    return (
        <FeatureSection id="features" height="fit">
            <Container>
                <Title align="center">FEATURES</Title>
                <Fade top duration={1000} delay={600} distance="30px">
                    <Row xs={1} md={2} className="g-4">
                        {FeatureContent.map((item, index) => (
                            <Col key={index}>
                                <FeatureItem>
                                    <FeatureIcon><i className="fas fa-dna fa-2x"></i></FeatureIcon>
                                    <FeatureBody>
                                        <FeatureTitle>{item.title}</FeatureTitle>
                                        <FeatureText>{item.text}</FeatureText>
                                    </FeatureBody>
                                </FeatureItem>
                            </Col>
                        ))}
                    </Row>
                </Fade>
            </Container>
        </FeatureSection>
    )
}

export default Features
